import { configService } from '@/settings/api-url'
import store from '@/store/store'
const actions = {
  async action_getCart({ commit, dispatch }) {
    try {
      let res = null;
      if (store.getters.getIsToken) {
        // Cuando el usuario está loggeado se trae su carrito
        res = await configService(`normal_user/cart`);
      } else if (
        store.getters.getCart &&
        store.getters.getCart.token_encode &&
        store.getters.getCart.id
      ) {
        // CUando no está loggeado pero tiene un cart-token
        const cartToken = store.getters.getCart.token_encode;
        const cartId = store.getters.getCart.id;
        res = await configService(`public/cart/cart_products/${cartId}`, {
          method: "GET",
          headers: {
            "cart-token": cartToken
          }
        });
      } else {
        // Cuando no tiene un token y se debe traer un nuevo carrito
        res = await configService(`public/cart/cart_products`);
      }
      if (res && res.data) {
        const cart = res.data;
        commit("CART", res.data);
        if(cart.coupon_data && cart.coupon_data.products) {
          commit("FREE_PRODUCTS", cart.coupon_data.products);
        }
      }
      await dispatch('action_removeInactiveProducts', store.getters.getCart);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_removeInactiveProducts({ dispatch, commit }, payload) {
    try {
      const cart = payload;
      const removeProducts = [];
      const removeProductsName = [];
      if (cart && cart.cart_products && cart.cart_products.length) {
        const products = cart.cart_products;
        products.map((product) => {
          if (
            (!product.is_activated || product.is_deleted) &&
            product.product_id &&
            product.quantity_total
          ) {
            const requestObject = {
              product_id: product.product_id,
              qty: product.quantity_total,
              type: "remove"
            };
            removeProducts.push(requestObject);
            removeProductsName.push(product.name);
          }
        });
      }
      if (removeProducts && removeProducts.length) {
        const payload = {
          products: [...removeProducts]
        };
        await dispatch("action_removeCartProducts", payload);
        commit('CART_DELETED_PRODUCTS', removeProductsName);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_postCart({ dispatch, commit }, payload) {
    try {
      let res = null;
      if(store.getters.getIsToken) {
        res = await configService(`cart`, {
          method: 'POST',
          data: payload
        });
        dispatch('action_getCart');
      } else if(store.getters.getCart && store.getters.getCart.token_encode) {
        res = await configService(`public/cart/cart_products`, {
          method: 'POST',
          data: payload,
          headers: {
            'cart-token': store.getters.getCart.token_encode
          }
        });
      } else {
        res = await configService(`public/cart/cart_products`, {
          method: 'POST',
          data: payload
        });
        if(res && res.data) {
          commit('CART', res.data);
        }
      }
      await dispatch('action_getCart');
      return res.data;
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_activateCartCoupon({ dispatch }, payload) {
    try {
      if(store.getters.getIsToken && store.getters.getCart) {
        await configService('coupons/activate', {
          method: 'POST',
          data: payload
        });
      } else if(store.getters.getCart && store.getters.getCart.token_encode) {
        const tokenEncode = store.getters.getCart.token_encode;
        await configService('public/cart/coupons/activate', {
          method: 'POST',
          data: payload,
          headers: {
            'cart-token': tokenEncode
          }
        });
      }
      await dispatch('action_getCart');
      await dispatch('action_removeInactiveProducts', store.getters.getCart);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_deactivateCartCoupon({ dispatch }, payload) {
    try {
      if(store.getters.getIsToken && store.getters.getCart) {
        await configService('coupons/deactivate', {
          method: 'POST',
          data: payload
        });
      } else if(store.getters.getCart && store.getters.getCart.token_encode) {
        const tokenEncode = store.getters.getCart.token_encode;
        await configService('public/cart/coupons/deactivate', {
          method: 'POST',
          data: payload,
          headers: {
            'cart-token': tokenEncode
          }
        });
      }
      await dispatch('action_getCart');
      await dispatch('action_removeInactiveProducts', store.getters.getCart);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_addCartProducts({ dispatch, commit }, payload) {
    try {
      let res = null;
      if(store.getters.getIsToken) {
        res = await configService('normal_user/cart/cart_products', {
          method: 'POST',
          data: payload
        });
      } else if(store.getters.getCart && store.getters.getCart.token_encode) {
        const tokenEncode = store.getters.getCart.token_encode;
        res = await configService('public/cart/cart_products', {
          method: 'POST',
          data: payload,
          headers: {
            'cart-token': tokenEncode
          }
        });
      } else {
        res = await configService('public/cart/cart_products', {
          method: 'POST',
          data: payload
        });
      }
      if(res && res.data) {
        commit('CART', res.data);
      } else {
        await dispatch('action_getCart');
      }
      await dispatch('action_removeInactiveProducts', store.getters.getCart);
      const index = store.getters.getCart.cart_products.findIndex(
        (item) => item.product_id == payload.products[0].product_id
      );
      if (index !== -1) {
        if (
          store.getters.getCart.cart_products[index].promo &&
          store.getters.getCart.cart_products[index].promo.max_promos_per_cart
        ) {
          const maxPromos =
            store.getters.getCart.cart_products[index].promo.max_promos_per_cart;
          if (
            maxPromos > 0 &&
            store.getters.getCart.cart_products[index].quantity_total - 1 === maxPromos
          ) {
            commit("LAST_PROMO_EXCEEDED_PRODUCT", store.getters.getCart.cart_products[index]);
            commit("OPEN_PROMO_EXCEEDED_MODAL", true);
          }
        }
      }
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getDonationProducts({ commit }, payload) {
    try {
      const res = await configService('donation_products')
      commit('DONATION_PRODUCTS', res.data)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_cleanCart({ commit, getters, dispatch }, data) {
    try {
      if(store.getters.getIsToken) {
        const res = await configService(`cart/all`, {
          method: 'DELETE'
        });
        if(res && res.data) {
          dispatch('action_getCart');
          return res.data;
        }
      } else {
        commit('CART', []);
        dispatch('action_getCart');
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async action_postCartProducts({ commit, dispatch }, payload) {
    try {
      const res = await configService('normal_user/cart/cart_products', {
        method: 'POST',
        data: payload
      });
      await dispatch('action_getCart');
    } catch (error) { 
      return Promise.reject(error);
    }
  },
  async action_removeCartProducts({ commit, dispatch }, payload) {
    try {
      let res = null;
      const requestObject = {
        ...payload,
        type: "remove"
      };
      if(store.getters.getIsToken) {
        res = await configService('normal_user/cart/cart_products', {
          method: 'POST',
          data: requestObject
        });
      } else if(store.getters.getCart && store.getters.getCart.token_encode) {
        const tokenEncode = store.getters.getCart.token_encode;
        res = await configService('public/cart/cart_products', {
          method: 'POST',
          data: requestObject,
          headers: {
            'cart-token': tokenEncode
          }
        });
      } else {
        res = await configService('public/cart/cart_products', {
          method: 'POST',
          data: requestObject
        });
      }
      if(res && res.data) {
        commit('CART', res.data);
      } else {
        await dispatch('action_getCart');
      }
      await dispatch('action_removeInactiveProducts', store.getters.getCart);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_setCartCommerceId({ commit, dispatch }, payload) {
    try {
      commit('CART_COMMERCE_ID', payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_linkCartWithUser({ dispatch }, payload) {
    try {
      if(store.getters.getIsToken && store.getters.getCart && store.getters.getCart.token_encode) {
        const cartToken = store.getters.getCart.token_encode;
        const res = await configService('normal_user/cart/cart_products/link_cart', {
          method: 'POST',
          headers: {
            'cart-token': cartToken
          }
        });
        if(res && res.data) {
          await dispatch('action_getCart');
          return res.data;
        }
      }
      await dispatch('action_removeInactiveProducts', store.getters.getCart);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_returnProducts({ commit, dispatch }, payload) {
    try {
      const data = {
        product_return: {
          products: [...payload.products],
          order_id: payload.orderId
        }
      };
      const res = await configService(`product_returns`, {
        method: "POST",
        data: data
      });
      if (res && res.data) {
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getUserValidCoupons({ commit, dispatch }) {
    try {
      const token = store.getters.getIsToken;
      const user = store.getters.getUser;
      if(token && user && user.id) {
        const response = await configService(`valid_coupons?normal_user=${user.id}`);
        if(response && response.data) {
          commit('USER_VALID_COUPONS', response.data);
          const ordersWithCoupons = [];
          response.data.forEach((item) => {
            if(item && item.product_returns && item.product_returns[0] && item.product_returns[0].order_id) {
              ordersWithCoupons.push(item.product_returns[0].order_id);
            }
          });
          commit('ORDERS_WITH_COUPONS', ordersWithCoupons);
          return response.data;
        }
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_validatePaymentMethod({ commit, dispatch }, payload) {
    try {
      const day = new Date();
      const card = payload;
      const bins = store.getters.getDaviviendaBins;
      let response = false;
      if(day.getDay() === 4 || day.getDay() === 5) {
        if (card && card.credit_card_bin && card.credit_card_bin > 0) {
          let index = bins.findIndex((item) => item == card.credit_card_bin);
          response = index !== -1;
        }
      }
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default actions
